import { render, staticRenderFns } from "./FabMenuItem.vue?vue&type=template&id=1e7d525a"
import script from "./FabMenuItem.vue?vue&type=script&lang=ts"
export * from "./FabMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports